export default __webpack_public_path__ + "static/media/blueArrow.e2f0ff58.svg";